import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=295da65a&scoped=true&lang=pug"
import script from "./CampaignSummary.js?vue&type=script&lang=js&external"
export * from "./CampaignSummary.js?vue&type=script&lang=js&external"
import style0 from "./CampaignSummary.sass?vue&type=style&index=0&id=295da65a&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295da65a",
  null
  
)

export default component.exports